import React from "react";
import Reveal from "../common/Reveal";

const VideoShowcase = () => {
  return (
    <section className="relative isolate overflow-hidden">
      <video
        className="absolute inset-0 h-full w-full object-cover"
        src="/home.mp4"
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/40 to-primary-950/60" />

      <Reveal className="relative mx-auto max-w-3xl px-4 py-40 text-center sm:px-6 lg:px-8">
        <span className="text-sm font-semibold uppercase tracking-wide text-accent-200">
          SMART FACTORY, POWERED BY MTST
        </span>
        <h2 className="mt-3 break-keep text-3xl font-bold leading-snug text-white sm:text-4xl">
          스마트한 제조의 시작,
          <br />
          지능형 공장이 곧 경쟁력입니다
        </h2>
        <p className="mt-4 break-keep text-base text-gray-200">
          현장의 복잡함은 줄이고, 생산의 효율은 극대화합니다
        </p>
      </Reveal>
    </section>
  );
};

export default VideoShowcase;
